import {
  Text,
  AuthUI,
  Button,
  Link,
  GreyGrey100,
  GreyGrey70,
  GreyGrey80,
  IndigoIndigo60,
  Primary14ExtendedRegular,
  PrimaryHeader32Regular
} from '@sequencehq/core-components'

export const ErrorPage = () => {
  return (
    <>
      <AuthUI.Section gap="24px">
        <AuthUI.Section gap="8px">
          <Text
            {...PrimaryHeader32Regular}
            textAlign="left"
            color={GreyGrey100}
            marginBottom="0px"
          >
            Unable to sign in
          </Text>
          <Text {...Primary14ExtendedRegular} color={GreyGrey80}>
            We apologize for the inconvenience. We are currently experiencing
            technical difficulties. Please try again later.
          </Text>
        </AuthUI.Section>

        <Link
          to="/login"
          data-testid="loginApp.errorPage.tryAgain"
          _hover={{
            textDecoration: 'none'
          }}
        >
          <Button
            variant="primary"
            fullWidth
            size="40px"
            style={{ fontSize: '14px', borderRadius: '8px' }}
          >
            Try again
          </Button>
        </Link>
      </AuthUI.Section>

      {/* Helper Text */}
      <Text
        fontSize="14px"
        color={GreyGrey70}
        textAlign="left"
        marginTop="24px"
        lineHeight="1.4"
        width="100%"
      >
        Check our{' '}
        <Link
          isExternal
          to="https://status.sequencehq.com/"
          color={IndigoIndigo60}
        >
          status page
        </Link>{' '}
        for more information
      </Text>
    </>
  )
}

export default ErrorPage
